module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hSeK8"))).then(() => module.bundle.root('8rm4T'));